import { getObfuscatedPhoneNumber } from '../../../../../util/account';
import { maskEmail } from '../../../../../util/email';
import { AUTH_TYPE } from '../../../../../constants/auth';

/**
 * Flattens a list of accounts into the available authentication options,
 * producing one option per email address (accounts can have multiple) plus an
 * option for the phone number when present. Each option carries the obfuscated
 * display value used by the UI.
 *
 * @param {Array<Object>} accounts The accounts associated with a QR code.
 * @returns {Array<{ key: String, account: Object, method: String, emailAddress?: String, phoneNumber?: String, label: String, value: String }>}
 */
const getAccountAuthOptions = (accounts = []) => {
  return accounts.reduce((options, account) => {
    (account.email_addresses ?? []).forEach(emailAddress => {
      if (!emailAddress) {
        return;
      }

      options.push({
        key: `${account.id}-${AUTH_TYPE.EMAIL}-${emailAddress}`,
        account,
        method: AUTH_TYPE.EMAIL,
        emailAddress,
        label: 'EMAIL',
        value: maskEmail(emailAddress),
      });
    });

    if (account.phone_number) {
      options.push({
        key: `${account.id}-${AUTH_TYPE.PHONE}`,
        account,
        method: AUTH_TYPE.PHONE,
        phoneNumber: account.phone_number,
        label: 'PHONE',
        value: getObfuscatedPhoneNumber(account.phone_number),
      });
    }

    return options;
  }, []);
};

export { getAccountAuthOptions };
